module.exports = __webpack_public_path__ + "static/media/wallet_dollar_card.3100a8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/carouselPropositions/wallet_dollar_card.png
// module id = 2183
// module chunks = 0